import React from 'react';
import { capitalizeText } from '../../step2/context/SelectedVariantContext/helper'
import withPopover from '../../../HOCs/withPopover';

const ProductMappingCard = ({
    productImage,
    productName,
    sku,
    options,
    onRemap,
    onAddMoreDesign
}) => {
    const CustomButton = ({ isOpen, ...rest }) => (
        <button
            className="button buttonSecondary"
            {...rest}
        >
            Remap
        </button>
    )

    const PopoverRemap = withPopover(CustomButton)
    return (
        <div className="productMappingCard">
            <div className="productInfo">
                <div className="productImage">
                    {productImage ? (
                        <img src={productImage} alt={productName} />
                    ) : (
                        <div className="productImagePlaceholder" />
                    )}
                </div>
                <div className="productDetails">
                    <h3 className="productName">{productName}</h3>
                    <div className="productMeta">
                        <span className="metaLabel">SKU:</span>
                        <span className="metaValue">{sku}</span>
                    </div>
                    {Array.isArray(options) &&
                        options.map((option, index) => (
                            <div className="productMeta" key={index}>
                                <span className="metaLabel">{capitalizeText(option.name)}:</span>
                                <span className="metaValue">{option.option}</span>
                            </div>
                        ))}
                </div>
            </div>
            <div className="productActions">
                <PopoverRemap
                    ContentComponent={({ togglePopover }) => (
                        <div className="remap-popover">
                            <div className='warring'>
                                <div className='icon'>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.99984 1.66699C5.39984 1.66699 1.6665 5.40033 1.6665 10.0003C1.6665 14.6003 5.39984 18.3337 9.99984 18.3337C14.5998 18.3337 18.3332 14.6003 18.3332 10.0003C18.3332 5.40033 14.5998 1.66699 9.99984 1.66699ZM10.8332 14.167H9.1665V12.5003H10.8332V14.167ZM10.8332 10.8337H9.1665V5.83366H10.8332V10.8337Z" fill="#FFC107" />
                                    </svg>
                                </div>
                                <div className='text'>This action will overwrite the existing mapping with the new one. Do you want to continue?</div>
                            </div>
                            <div className='footer'>
                                <button className="button buttonText" onClick={togglePopover}>Cancel</button>
                                <button className="button buttonPrimary" onClick={onRemap}>Confirm</button>
                            </div>
                        </div>
                    )}
                    placement="bottom"
                    trigger="click"
                    popoverOffsetY={0}
                />
                <button
                    className="button buttonPrimary"
                    onClick={onAddMoreDesign}
                >
                    Add more design
                </button>
            </div>
        </div>
    );
};

export default ProductMappingCard;
